import { Button, Tooltip, IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import React from 'react';
import { handleValidateCodevalue } from '../Utility/constant';
import { useSelector } from 'react-redux';

const AddMoreButton = ({ setRows, addParams,visible, title }) => {
  const internationalise = useSelector(
    state => state?.internationalise?.currentHashMapData
  );

  const addRow = () => {
    setRows(prev => [...prev, addParams]);
  };

  if (!visible) return null;
  return (
    <Tooltip title={handleValidateCodevalue(internationalise, "COMMON_ADD_MORE")}>
      <Button
        sx={{ marginLeft: "0px !important",height : "30px",py:1 }}
        className="secondry-edit-btn btn-space"
        variant="outlined"
        onClick={addRow}
      >
        {title || handleValidateCodevalue(internationalise, "COMMON_ADD_MORE")}
      </Button>
    </Tooltip>
  );
};

const RemoveAddedFieldButton = ({ setRows, index, visible }) => {
  const removeRow = () => {
    setRows(prev => prev.filter((_, i) => i !== index));
  };

  if (!visible) return null;

  return (
    <IconButton onClick={removeRow} sx = {{width : "fit-content"}}>
      <CloseIcon fontSize="small" />
    </IconButton>
  );
};

export { AddMoreButton, RemoveAddedFieldButton };